var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_-_dokumentumtar",
    "data-name": "Component - dokumentumtar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 18,
    viewBox: "0 0 13.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M4,4.25A2.25,2.25,0,0,1,6.25,2h5.159A2.25,2.25,0,0,1,13,2.659L16.841,6.5A2.25,2.25,0,0,1,17.5,8.091V17.75A2.25,2.25,0,0,1,15.25,20h-9A2.25,2.25,0,0,1,4,17.75ZM6.25,11A1.125,1.125,0,0,1,7.375,9.875h6.75a1.125,1.125,0,0,1,0,2.25H7.375A1.125,1.125,0,0,1,6.25,11Zm1.125,3.375a1.125,1.125,0,0,0,0,2.25h6.75a1.125,1.125,0,0,0,0-2.25Z",
    transform: "translate(-4 -2)",
    fill: "#5f6266",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ca40be0db443a5bb6933db7e1e6454f9.svg";
export { ForwardRef as ReactComponent };